import { useEffect } from "react";
import { ListState, RECEIVE_LIST } from ".";
import { subscribeToolkitReduxDispatches } from "src/state/toolkitReduxStore";
import { toolkitListActions } from "./toolkitListStore";

export function useToolkitListRuntime() {
  useEffect(() => {
    const unsubscribe = subscribeToolkitReduxDispatches((action) => {
      if (action.type !== RECEIVE_LIST) {
        return;
      }

      toolkitListActions.setList((action.payload ?? {}) as Partial<ListState>);
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
